import React, { useState } from "react";
import { TextInput } from '../TextInput/NewTextInput';
import VariablePicker from '../VariablePicker/VariablePicker';
import { Checkboxes, Dropdown } from '..';
import ModifyDate from "../../FlowConfigurationForms/Date/ModifyDate/ModifyDate";

const ConditionForm = ({ condition, conditionInfo, inputName, boolValue, onTypeChange, variables, setOpenVariable, variableRender }) => {
    const [modifyDate, setModifyDate] = useState(condition != 'date' ? false : conditionInfo.fields.modifyDate?.value);
    const label = 'CONTENT.CONFIGURATION-FORM.CONDITION.MODAL.';
    const options = {
        dropdownTable: {
            data: [
                { value: 'row', label: label + 'ROW' },
                { value: 'column', label: label + 'COLUMN' }
            ],
            defaultValue: 'row'
        },
        dropdownPing: {
            data: [
                { value: 'true', label: label + 'SUCCESS' },
                { value: 'false', label: label + 'FAIL' }
            ],
            defaultValue: 'true'
        },
        dropdownDict: {
            data: [
                { value: 'key', label: label + 'KEY' }
            ],
            defaultValue: 'key'
        },
        dropdownArray: {
            data: [
                { value: 'number', label: 'Number' },
                { value: 'string', label: 'String' },
                { value: 'boolean', label: 'Boolean' }
            ],
            defaultValue: ''
        },
        checkboxes: { label: label + 'CASE' },
        modifyDate: { label: label + 'MODIFY-DATE' },
        date: { label: 'Date' },
        time: { label: 'Time' }
    }

    const getLabel = () => {
        return inputName === 'firstValue' ? 'Source Value' : 'Target Value';
    }
    
    function changeModifyDate(event) {
        if (!event.value) {
        } else {
        }
        setModifyDate(event.value);
        conditionInfo.fields.modifyDate = { value: event.value };
    }
    
    return (
        <div className="form-element">
            {condition === 'boolean' &&
                <div>{getLabel()}
                    <div className="condition-tabs">
                        <button className={boolValue === 'true' ? 'condition-active' : ''}
                            value="true" onClick={onTypeChange}>
                            True
                        </button>
                        <button className={boolValue === 'false' ? 'condition-active' : ''}
                            value="false" onClick={onTypeChange}>
                            False
                        </button>
                        <button className={boolValue === 'variable' ? 'condition-active' : ''}
                            value="variable" onClick={onTypeChange}>
                            Variable
                        </button>
                    </div>
                    {boolValue === 'variable' &&
                        // <TextInput action={conditionInfo} inputName={inputName} variables={variables} setOpenVariable={setOpenVariable}/>
                        <VariablePicker action={conditionInfo} inputName={inputName} variables={variables} setOpenVariable={setOpenVariable} variableRender={variableRender} filter="boolean" condition />
                    }
                </div>
            }
            {condition === 'datatable' &&
                <div>
                    {inputName === 'firstValue' ? <>
                        <Dropdown action={conditionInfo} inputName="option" options={options.dropdownTable} />
                        <div className="form-element">
                            {getLabel()}
                            {/* <TextInput action={conditionInfo} inputName={inputName} variables={variables} setOpenVariable={setOpenVariable} /> */}
                            <VariablePicker action={conditionInfo} inputName={inputName} variables={variables} setOpenVariable={setOpenVariable} filter="data table" condition />
                        </div></> :
                        <div className="form-element">
                            {getLabel()}
                            <TextInput action={conditionInfo} inputName={inputName} variables={variables} setOpenVariable={setOpenVariable} include={['number']} />
                            {/* <VariablePicker action={conditionInfo} inputName={inputName} variables={variables} setOpenVariable={setOpenVariable} filter="data table"/> */}
                        </div>
                    }
                </div>
            }
            {condition === 'ping' &&
                <div>
                    {inputName === 'firstValue' &&
                        <Dropdown action={conditionInfo} inputName="secondValue" options={options.dropdownPing} />}
                    <div className="form-element">
                        {getLabel()}
                        <TextInput action={conditionInfo} inputName={inputName} variables={variables}
                            setOpenVariable={setOpenVariable} />
                    </div>
                </div>
            }
            {condition === 'dictionary' &&
                <div>
                    <div className="form-element">
                        {getLabel()}
                        {/* <TextInput action={conditionInfo} inputName={inputName} variables={variables} setOpenVariable={setOpenVariable}/> */}
                        <VariablePicker action={conditionInfo} inputName={inputName} variables={variables} setOpenVariable={setOpenVariable} filter="dictionary" condition />
                    </div>
                    {inputName === 'firstValue' && <Dropdown action={conditionInfo} inputName="option" options={options.dropdownDict} />}
                </div>
            }
            {condition === 'length' &&
                <div>{getLabel()}
                    <TextInput action={conditionInfo} inputName={inputName} variables={variables} setOpenVariable={setOpenVariable}
                        include={['dictionary', 'data table', 'array', 'string', 'number']} />
                </div>
            }
            {condition === 'string' &&
                <div>{getLabel()}
                    <TextInput action={conditionInfo} inputName={inputName} variables={variables} setOpenVariable={setOpenVariable} />
                    {inputName === 'secondValue' &&
                        <Checkboxes action={conditionInfo} inputName="caseSensitive" options={options.checkboxes} />}
                </div>
            }
            {condition === 'number' &&
                <div>{getLabel()}
                    {/*<div className="condition-tabs">
                        <button className={boolValue === 'true' ? 'condition-active' : ''} value="true" onClick={onTypeChange}>
                            Number
                        </button>
                        <button className={boolValue === 'variable' ? 'condition-active' : ''} value="variable" onClick={onTypeChange}>
                            Variable
                        </button>
                    </div>*/}
                    <TextInput action={conditionInfo} inputName={inputName} variables={variables} setOpenVariable={setOpenVariable} />
                    {/*{boolValue === 'variable' &&
                        <VariablePicker action={conditionInfo} inputName={inputName} variables={variables} setOpenVariable={setOpenVariable} filter="number" variableRender={variableRender}/> :
                    }*/}
                </div>
            }
            {condition === 'array' &&
                <div>{getLabel()}
                    <TextInput action={conditionInfo} inputName={inputName} variables={variables} setOpenVariable={setOpenVariable} />
                    {/*<VariablePicker action={conditionInfo} inputName={inputName} variables={variables} setOpenVariable={setOpenVariable} filter="array" variableRender={variableRender}/>*/}
                    {inputName === 'firstValue' && <div className="form-element">Type
                        <Dropdown action={conditionInfo} inputName="type" options={options.dropdownArray} />
                    </div>}
                </div>
            }
            {condition === 'object' &&
                <div>{getLabel()}
                    <TextInput action={conditionInfo} inputName={inputName} variables={variables} setOpenVariable={setOpenVariable} />
                </div>
            }
            {condition === 'date' &&
                <div>{getLabel()}
                    <VariablePicker action={conditionInfo} inputName={inputName} variables={variables} setOpenVariable={setOpenVariable} filter="date" condition />
                    {inputName === 'secondValue' &&
                        <div>
                            <Checkboxes action={conditionInfo} inputName="modifyDate" options={options.modifyDate} onChange={changeModifyDate} />
                            {
                                modifyDate && <ModifyDate action={conditionInfo} variables={variables} setOpenVariable={setOpenVariable} variableRender={variableRender} fromCondition={true} />
                            }
                        </div>}
                </div>
            }
        </div>
    );
}
export default ConditionForm;
// date old data
//<div className="condition-tabs" style={{ marginTop: 5 }}>
//    <button className={boolValue === 'true' ? 'condition-active' : ''}
//        value="true" onClick={onTypeChange}>
//        Date
//    </button>
//    <button className={boolValue === 'variable' ? 'condition-active' : ''}
//        value="variable" onClick={onTypeChange}>
//        Variable
//    </button>
//</div>
//{
//    boolValue === 'variable' ?
    //<TextInput action={conditionInfo} inputName={inputName} variables={variables} setOpenVariable={setOpenVariable} /> :
    //<>
     //   <div style={{ marginTop: -15, marginBottom: -5 }}>
      //      <Checkboxes action={conditionInfo} inputName={getDateType('date')} onChange={handleDateType} options={options.date} />
       //     <Checkboxes action={conditionInfo} inputName={getDateType('time')} onChange={handleDateType} options={options.time} />
       // </div>
       // {/* <FormControlLabel label={'Date'} style={{ marginTop: -15, marginBottom: -5 }}
       //                         control={<Checkbox checked={false} size="small" color="#C4C4C4" onChange={()=>{}} />} />
        //                    <FormControlLabel label={'Time'} style={{ marginTop: -15, marginBottom: -5 }}
         //                       control={<Checkbox checked={false} size="small" color="#C4C4C4" onChange={()=>{}} />} /> */}
        //<DateTime action={conditionInfo} inputName={inputName}
         //   type={conditionInfo.fields[getDateType('date')]?.value &&
          //      conditionInfo.fields[getDateType('time')]?.value ? 'datetime-local' :
           //     conditionInfo.fields[getDateType('date')]?.value ? 'date' :
            //        conditionInfo.fields[getDateType('time')]?.value ? 'time' :
             //           'datetime-local'} />
    //</>
    // <VariablePicker action={conditionInfo} inputName={inputName} variables={variables} setOpenVariable={setOpenVariable} variableRender={variableRender} filter="date"/>
//}